import React from 'react'
export const ezeth = {
  path: (
    <>
      <path
        d="M28.5 16.0004C28.5 22.9042 22.9035 28.5008 16 28.5008C9.09647 28.5008 3.5 22.9042 3.5 16.0004C3.5 9.0966 9.09647 3.5 16 3.5C22.9035 3.5 28.5 9.0966 28.5 16.0004Z"
        fill="white"
        stroke="#E5E4E6"
      />
      <path d="M16 6.50049L22 15.5005L16 19.5005L10 15.5005L16 6.50049Z" fill="#C2ED68" />
      <path d="M10 16.5005L16 20.5005L22 16.5005L16 24.5005L10 16.5005Z" fill="#C2ED68" />
      <path d="M16 19.5005V6.50049L22 15.5005L16 19.5005Z" fill="#D9D9D9" />
      <path d="M16 19.5005V6.50049L22 15.5005L16 19.5005Z" fill="#90C228" />
      <path d="M16 24.5005V20.5005L22 16.5005L16 24.5005Z" fill="#6B8D1D" />
      <path d="M10 15.5005L16 13.5005L22 15.5005L16 19.5005L10 15.5005Z" fill="#E3F7B9" />
      <path d="M16 19.5005V13.5005L22 15.5005L16 19.5005Z" fill="#A3DB2E" />
    </>
  ),
  viewBox: '0 0 32 32',
}
